// TODO: Move all static local storage keys into this file.
export const HAS_SEEN_MFA_INTERSTIAL_IN_PAST = 'mfa-inter-seen';
export const MFA_AUTH_CHANNEL = 'capsule-mfa-auth-channel';
export const ESCRIPT_ONBOARDING_STEP = 'escript_onboarding.step';
export const ESCRIPT_ONBOARDING_ALLERGIES_FORM = 'escript_onboarding.form.allergies';
export const ESCRIPT_ONBOARDING_OTHER_MEDS_FORM = 'escript_onboarding.form.other_meds';
export const ESCRIPT_ONBOARDING_FINISHED = 'escript_onboarding.finished';
export const EXCHANGE_TOKEN_LOCAL_STORAGE_KEY = '1d49a2ce-f441-4923-962d-3de41aa60e18';
export const LAST_SHOWN_APP_DOWNLOAD_INTERSTITIAL = 'last-shown-app-download-interstitial';
export const HEALTH_PROFILE_DATA_FORM = 'health_profile_data';
